import { useState } from "react";
import PropTypes from "prop-types";

export const EditInputs = ({ defaultValue, onBlur, disabled, className }) => {
  
  const [edit, setEdit] = useState(false);

  const handleBlur = (event) => {
    setEdit(false);
    onBlur(event);
  };

  const formatRHSRate = (rate) => {
    if (rate === null || rate === undefined) {
      return 0; // Return an empty string if rate is null, undefined
    } else {
      return parseFloat(rate).toFixed(2); // Format the rate with 2 decimal places
    }
  };

  return (
    <>
      {edit && !disabled ? (
        <input
          className={className}
          type="text"
          defaultValue={defaultValue}
          onBlur={handleBlur}
          disabled={disabled}
         
        />
      ) : (
        <>
          <div
           
            className="text-right editable-pointer-events"
            onClick={() => !disabled && setEdit(true)}
          >
            {formatRHSRate(defaultValue)}
          </div>
        </>
      )}
    </>
  );
};

EditInputs.prototype = {
  defaultValue: PropTypes.any,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};
